import React from "react";
import PropTypes from "prop-types";
import {Button, Typography, makeStyles, Box, Grid} from "@material-ui/core";
import {StreamlineIcon} from "@hapinest/theme";
import ArrowRight from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-right-1.svg";
import { hexToRgb } from "../../../common/theme";
import { useI18N } from "../../../common/common";

const useStyles = makeStyles((theme) => ({
    selectionContainer: {
        height: "100%",
        width: "100%",
        border: "1px solid " + theme.palette.borders.line.light,
        borderRadius: theme.spacing(0.75),
        overflow: "hidden",
        marginTop: theme.spacing(1.5),
    },
    buttonSubtitle: {
        marginTop: theme.spacing(1),
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textMedium)
    },
    containerWrapper: {
        padding: theme.spacing(1)
    }
}));

const CallUsOptions = (({onQuestionCall}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <>
            <Typography
                variant="h3"
                align="center"
            >
                {i18n("dialog.contact.call_us.title")}
            </Typography>

            <Box
                mt={3.5}
            >
                <Button
                    onClick={() => onQuestionCall("resort-question")}
                    className={classes.selectionContainer}
                >
                    <Grid
                        container
                        className={classes.containerWrapper}
                    >
                        <Grid
                            item
                            xs={10}
                        >
                            <Box
                                display="flex"
                                flexDirection={"column"}
                                justifyContent="center"
                                textAlign="left"
                                height={"100%"}
                            >
                                <Typography
                                    variant="subtitle1"
                                >
                                    {i18n("dialog.contact.call_us.resort_question.title")}
                                </Typography>

                                <Typography
                                    variant="caption"
                                    className={classes.buttonSubtitle}
                                >
                                    {i18n("dialog.contact.call_us.resort_question.subtitle")}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid
                            item
                            xs={2}
                        >
                            <Box
                                display="flex"
                                flexDirection={"column"}
                                justifyContent="center"
                                alignItems={"flex-end"}
                                height={"100%"}
                            >
                                <StreamlineIcon
                                    className={classes.arrowIconRight}
                                    size={24}
                                >
                                    <ArrowRight />
                                </StreamlineIcon>
                            </Box>

                        </Grid>

                    </Grid>
                </Button>

                <Button
                    onClick={() => onQuestionCall("general-question")}
                    className={classes.selectionContainer}
                >
                    <Grid
                        container
                        className={classes.containerWrapper}
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <Box
                                display="flex"
                                flexDirection={"column"}
                                justifyContent="center"
                                textAlign="left"
                                height={"100%"}
                            >
                                <Typography
                                    variant="subtitle1"
                                >
                                    {i18n("dialog.contact.call_us.general_question.title")}
                                </Typography>

                                <Typography
                                    variant="caption"
                                    className={classes.buttonSubtitle}
                                >
                                    {i18n("dialog.contact.call_us.general_question.subtitle")}
                                </Typography>
                            </Box>
                        </Grid>

                    </Grid>
                </Button>

            </Box>
        </>

    );
});

CallUsOptions.propTypes = {
    onQuestionCall: PropTypes.func,
};

export default CallUsOptions;
